import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';
import EmailNotificationAPI from '../../services/EmailNotificationsApi';

export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useEmailNotificationPresenter = tableRef => {
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
 
  const [open, setOpen] = useState(false);

  const [email, setEmail] = useState('');
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [newEmail, setNewEmail] = useState('');


  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    setRowsToShow(rows);
    
  }, [rows]);

  const cleanFilters = () => {
    setEmail('');
    setSelectedSupplier(null);
  }

  const search = reload => {

    const request = reload
      ? oldSearchRequest
      : {
        SupplierId: selectedSupplier ? selectedSupplier.id : '',
        Email: email
      }

    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);
    setSelectedRows([]);

    EmailNotificationAPI.get(request)
      .then(res => setRows(res.data))
      .catch(error => showError('Error al obtener los registros'))
      .finally(() => setLoading(false));
  };

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if ((errors[i++] = email && !regexEmail.test(email))) {
      errorMessages.push('Debe ingresar un email válido');
    }
    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

   const reloadGrid = () => search(true);

  const modify = () => {
    const request = {
        SupplierId: selectedRows[0].supplierId,
        EmailId: selectedRows[0].emailId,
        NewEmail: newEmail
      }

      EmailNotificationAPI.modify(request)
      .then(res => {
        showSuccess('El email se ha modificado exitosamente');
        
        reloadGrid();
      })
      .catch(error => {
        if(error.response){
          if(error.response.status === 409){
            showWarning(error.response.data);
          } else if( error.response.status === 500){
            showError('Error al modifcar el email')
          }
        }
        
      })
      .finally(() => setLoading(false));
  }

  const deleteEmail = () => {
    const request = {
      SupplierId: selectedRows[0].supplierId,
      EmailId: selectedRows[0].emailId,
      
    }

    EmailNotificationAPI.delete(request).then((res) => {
      showSuccess('Email eliminado exitosamente');
      reloadGrid();
    })
    .catch((err) => {
      showError("No se pudo eliminar el email")
    })
  }

  return {
    search,
    rows: rowsToShow,
    firstLoad,
    loading,
    selectedSupplier,
    setSelectedSupplier,
    validateAndSearch,
    newEmail,
    setNewEmail,
    email,
    setEmail,
    cleanFilters,
    gridFunctions: {
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      gridActions: {
        modify,
        reloadGrid,
        deleteEmail
        
      },
    },
  };
};

export default useEmailNotificationPresenter;